import FAQDrawerPanel from 'modules/faq/components/faq-drawer-panel'
import { DrawerKey } from 'modules/drawer/state/drawer-types'
import OrderCommentDrawerPanel from 'modules/order/components/comment/order-comment-drawer-panel'
import OrderDedicationDrawerPanel from 'modules/order/components/dedication/order-dedication-drawer-panel'
import OrderDesignationDrawerPanel from 'modules/order/components/designation/order-designation-drawer-panel'
import OrderDetailsDrawerPanel from 'modules/order/components/details-drawer/components/details-drawer-panel/order-details-drawer-panel'
import OrderDoubleTheDonationDrawerPanel from 'modules/order/components/double-the-donation/order-double-the-donation-drawer-panel'

export const drawerKeyToComponentMap: { [key in DrawerKey]: React.ComponentType } = {
  faq: FAQDrawerPanel,
  comment: OrderCommentDrawerPanel,
  dedication: OrderDedicationDrawerPanel,
  designation: OrderDesignationDrawerPanel,
  doubleTheDonation: OrderDoubleTheDonationDrawerPanel,
  orderDetails: OrderDetailsDrawerPanel,
}

export const focusOnElement = (dataId: string) => {
  return () => {
    if (typeof document === 'undefined') return

    const openerButton = document.querySelector(`[data-id="${dataId}"]`) as HTMLElement

    if (openerButton) {
      openerButton.focus()
    }
  }
}
